import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MessageCircle, UserPlus, Download, Share2 } from 'lucide-react';
import { toast } from 'sonner';
import { waLink } from '@/config/contact';

export const PROMO_VIDEO = {
  hd: '/media/BITZ_CLUB_A_World_of_Privileges_HD.mp4',
  whatsapp: '/media/BITZ_CLUB_A_World_of_Privileges_WhatsApp.mp4',
  poster: '/media/BITZ_CLUB_A_World_of_Privileges_poster.jpg',
};

const ENQUIRY_MSG = 'Hello BITZ Club, I watched your presentation and would like to know more about membership.';

const sharePage = async () => {
  const url = `${window.location.origin}/discover`;
  const data = { title: 'BITZ CLUB — A World of Privileges', text: 'One Membership. A World of Experiences.', url };
  if (navigator.share) {
    try {
      await navigator.share(data);
    } catch {
      /* user closed the share sheet */
    }
    return;
  }
  try {
    await navigator.clipboard.writeText(url);
    toast.success('Link copied. Paste it anywhere to share.');
  } catch {
    toast.info(`Share this link: ${url}`, { duration: 8000 });
  }
};

const btn = 'w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full text-sm font-semibold transition-colors duration-200';

export const DiscoverVideoSection = ({ id = 'discover' }) => (
  <section id={id} className="py-16 sm:py-24 bg-[#0A0A0B]" data-testid="discover-video-section">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="text-center mb-10">
        <p className="text-[#D4AF37] text-xs sm:text-sm tracking-[0.3em] uppercase mb-3">Watch Our Presentation</p>
        <h2 className="text-3xl sm:text-5xl font-bold text-white mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>Discover BITZ CLUB</h2>
        <p className="text-[#E8D9A8] italic text-base sm:text-lg" style={{ fontFamily: 'Playfair Display, serif' }}>One Membership. A World of Experiences.</p>
      </motion.div>

      <motion.div initial={{ opacity: 0, scale: 0.97 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
        className="relative rounded-2xl overflow-hidden border border-[#D4AF37]/40 shadow-[0_30px_80px_-20px_rgba(212,175,55,0.25)] bg-black">
        <video controls playsInline preload="none" poster={PROMO_VIDEO.poster} className="w-full aspect-video" data-testid="discover-video-player">
          <source src={PROMO_VIDEO.hd} type="video/mp4" />
        </video>
      </motion.div>

      <div className="mt-10 flex flex-col sm:flex-row flex-wrap items-center justify-center gap-3">
        <a href={waLink(ENQUIRY_MSG)} target="_blank" rel="noopener noreferrer" className={`${btn} bg-[#D4AF37] text-black hover:bg-[#E8C658]`} data-testid="discover-enquire-btn">
          <MessageCircle className="w-4 h-4" /> Enquire About Membership
        </a>
        <Link to="/register" className={`${btn} border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37]/10`} data-testid="discover-join-btn">
          <UserPlus className="w-4 h-4" /> Become a Member
        </Link>
        <a href={PROMO_VIDEO.whatsapp} download className={`${btn} border border-white/20 text-white hover:bg-white/10`} data-testid="discover-download-btn">
          <Download className="w-4 h-4" /> Download (WhatsApp)
        </a>
        <a href={PROMO_VIDEO.hd} download className={`${btn} border border-white/20 text-white hover:bg-white/10`} data-testid="discover-download-hd-btn">
          <Download className="w-4 h-4" /> Download Full HD
        </a>
        <button type="button" onClick={sharePage} className={`${btn} border border-white/20 text-white hover:bg-white/10`} data-testid="discover-share-btn">
          <Share2 className="w-4 h-4" /> Share
        </button>
      </div>
    </div>
  </section>
);
